import type { LucideIcon } from 'lucide-react';
import {
  Ambulance,
  Apple,
  Armchair,
  ArrowLeftRight,
  Baby,
  Banknote,
  BatteryMedium,
  BedDouble,
  Beer,
  Bike,
  Bird,
  Bitcoin,
  BookOpen,
  Briefcase,
  Building2,
  Bus,
  Cake,
  Camera,
  Candy,
  Car,
  CarFront,
  Cat,
  Church,
  CircleDollarSign,
  CircleParking,
  ClipboardList,
  Cloud,
  Coffee,
  Coins,
  Compass,
  Construction,
  Cookie,
  Cpu,
  CreditCard,
  Crown,
  Dices,
  Dog,
  Drama,
  Drill,
  Drumstick,
  Droplets,
  Dumbbell,
  Egg,
  Fan,
  FileText,
  Film,
  Fish,
  FlaskConical,
  Flower2,
  Fuel,
  Gamepad2,
  Gem,
  Gift,
  GlassWater,
  Globe,
  GraduationCap,
  Guitar,
  Hammer,
  HardDrive,
  HardHat,
  Handshake,
  Headphones,
  HeartHandshake,
  Home,
  Hospital,
  Hotel,
  HousePlug,
  IceCream,
  Key,
  Landmark,
  LampDesk,
  Laptop,
  Leaf,
  Lock,
  Luggage,
  Mail,
  Map as MapIcon,
  MapPin,
  Martini,
  Medal,
  Mic,
  Microscope,
  Milk,
  Monitor,
  Moon,
  Motorbike,
  Mountain,
  Music,
  Newspaper,
  Package2,
  Paintbrush,
  PaintRoller,
  ParkingMeter,
  PartyPopper,
  PawPrint,
  PenLine,
  Percent,
  Piano,
  PiggyBank,
  Pill,
  PillBottle,
  Pizza,
  Plane,
  Plug,
  Printer,
  PlugZap,
  Popcorn,
  Rabbit,
  Receipt,
  Recycle,
  ScrollText,
  Router,
  Rss,
  Sailboat,
  Scale,
  School,
  Scissors,
  Scooter,
  Send,
  Server,
  Shield,
  ShieldCheck,
  Ship,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Smartphone,
  Snowflake,
  Sofa,
  Sparkles,
  Sprout,
  Stethoscope,
  Store,
  Sun,
  Syringe,
  Tablet,
  Tag,
  Tent,
  TestTube,
  Thermometer,
  Ticket,
  TrainFront,
  TramFront,
  TreePine,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Tv,
  Umbrella,
  User,
  Users,
  Utensils,
  Vegan,
  Video,
  Wallet,
  Watch,
  WashingMachine,
  Webcam,
  Wheat,
  Wine,
  Wrench,
  Zap,
} from 'lucide-react';

const STROKE = 1.65;

/** Valori salvati in Dynamo (campo `icon` categoria). */
export const CATEGORY_ICON_CHOICES: { id: string; label: string; Icon: LucideIcon }[] = [
  /* — Base (id storici) — */
  { id: 'tag', label: 'Generico', Icon: Tag },
  { id: 'cart', label: 'Spesa', Icon: ShoppingCart },
  { id: 'home', label: 'Casa', Icon: Home },
  { id: 'car', label: 'Auto', Icon: Car },
  { id: 'fuel', label: 'Carburante', Icon: Fuel },
  { id: 'food', label: 'Ristorante', Icon: Utensils },
  { id: 'coffee', label: 'Bar', Icon: Coffee },
  { id: 'health', label: 'Salute', Icon: Stethoscope },
  { id: 'pharmacy', label: 'Farmacia', Icon: Pill },
  { id: 'kids', label: 'Bambini', Icon: Baby },
  { id: 'pet', label: 'Animali', Icon: PawPrint },
  { id: 'gift', label: 'Regali', Icon: Gift },
  { id: 'travel', label: 'Viaggi', Icon: Plane },
  { id: 'train', label: 'Treno', Icon: TrainFront },
  { id: 'sport', label: 'Sport', Icon: Dumbbell },
  { id: 'game', label: 'Videogiochi', Icon: Gamepad2 },
  { id: 'phone', label: 'Telefono', Icon: Smartphone },
  { id: 'pc', label: 'Computer', Icon: Laptop },
  { id: 'bolt', label: 'Utenze', Icon: Zap },
  { id: 'shirt', label: 'Abbigliamento', Icon: Shirt },
  { id: 'book', label: 'Libri', Icon: BookOpen },
  { id: 'work', label: 'Lavoro', Icon: Briefcase },
  { id: 'money', label: 'Contanti', Icon: Banknote },
  { id: 'bank', label: 'Banca', Icon: Landmark },
  { id: 'card', label: 'Carta di credito', Icon: CreditCard },

  /* — Trasporti — */
  { id: 'bus', label: 'Autobus', Icon: Bus },
  { id: 'tram', label: 'Tram', Icon: TramFront },
  { id: 'motorbike', label: 'Moto', Icon: Motorbike },
  { id: 'scooter', label: 'Monopattino', Icon: Scooter },
  { id: 'car_front', label: 'Auto (alt.)', Icon: CarFront },
  { id: 'parking', label: 'Parcheggio', Icon: CircleParking },
  { id: 'parking_meter', label: 'Sosta a pagamento', Icon: ParkingMeter },
  { id: 'truck', label: 'Furgone / traslochi', Icon: Truck },
  { id: 'delivery', label: 'Spedizioni', Icon: Package2 },
  { id: 'ship', label: 'Nave', Icon: Ship },
  { id: 'sailboat', label: 'Barca', Icon: Sailboat },
  { id: 'map', label: 'Mappa', Icon: MapIcon },
  { id: 'pin', label: 'Luogo', Icon: MapPin },
  { id: 'globe', label: 'Estero', Icon: Globe },
  { id: 'compass', label: 'Turismo', Icon: Compass },

  /* — Casa e quotidiano — */
  { id: 'key', label: 'Affitto / chiavi', Icon: Key },
  { id: 'lock', label: 'Sicurezza', Icon: Lock },
  { id: 'sofa', label: 'Arredamento', Icon: Sofa },
  { id: 'armchair', label: 'Poltrona', Icon: Armchair },
  { id: 'lamp', label: 'Illuminazione', Icon: LampDesk },
  { id: 'washing', label: 'Lavatrice / lavanderia', Icon: WashingMachine },
  { id: 'fan', label: 'Climatizzazione', Icon: Fan },
  { id: 'thermo', label: 'Riscaldamento', Icon: Thermometer },
  { id: 'house_plug', label: 'Elettricità casa', Icon: HousePlug },
  { id: 'droplets', label: 'Acqua', Icon: Droplets },
  { id: 'paint_roller', label: 'Imbiancatura', Icon: PaintRoller },
  { id: 'hammer', label: 'Fai-da-te', Icon: Hammer },
  { id: 'drill', label: 'Trapano / lavori', Icon: Drill },
  { id: 'wrench', label: 'Riparazioni', Icon: Wrench },
  { id: 'construction', label: 'Cantiere', Icon: Construction },
  { id: 'hard_hat', label: 'Muratura / edile', Icon: HardHat },

  /* — Cibo e bevande — */
  { id: 'shopping_bag', label: 'Shopping bag', Icon: ShoppingBag },
  { id: 'basket', label: 'Cesta', Icon: ShoppingBasket },
  { id: 'store', label: 'Negozio', Icon: Store },
  { id: 'factory', label: 'Grande distribuzione', Icon: Building2 },
  { id: 'apple', label: 'Frutta / bio', Icon: Apple },
  { id: 'wheat', label: 'Pane / cereali', Icon: Wheat },
  { id: 'milk', label: 'Latticini', Icon: Milk },
  { id: 'egg', label: 'Alimentari', Icon: Egg },
  { id: 'cookie', label: 'Dolci', Icon: Cookie },
  { id: 'candy', label: 'Caramelle', Icon: Candy },
  { id: 'cake', label: 'Torte / feste', Icon: Cake },
  { id: 'pizza', label: 'Pizza / fast food', Icon: Pizza },
  { id: 'icecream', label: 'Gelato', Icon: IceCream },
  { id: 'wine', label: 'Vino', Icon: Wine },
  { id: 'beer', label: 'Birra', Icon: Beer },
  { id: 'glass', label: 'Bevande', Icon: GlassWater },
  { id: 'martini', label: 'Aperitivo', Icon: Martini },
  { id: 'drumstick', label: 'Carne', Icon: Drumstick },
  { id: 'fish_food', label: 'Pesce', Icon: Fish },
  { id: 'vegan', label: 'Vegano', Icon: Vegan },

  /* — Tempo libero e cultura — */
  { id: 'film', label: 'Cinema', Icon: Film },
  { id: 'tv', label: 'TV / streaming', Icon: Tv },
  { id: 'video', label: 'Video', Icon: Video },
  { id: 'music', label: 'Musica', Icon: Music },
  { id: 'headphones', label: 'Audio', Icon: Headphones },
  { id: 'guitar', label: 'Strumenti', Icon: Guitar },
  { id: 'piano', label: 'Piano', Icon: Piano },
  { id: 'mic', label: 'Eventi live', Icon: Mic },
  { id: 'ticket', label: 'Biglietti', Icon: Ticket },
  { id: 'popcorn', label: 'Svago cinema', Icon: Popcorn },
  { id: 'drama', label: 'Teatro', Icon: Drama },
  { id: 'dice', label: 'Giochi da tavolo', Icon: Dices },
  { id: 'trophy', label: 'Competizioni', Icon: Trophy },
  { id: 'medal', label: 'Premi', Icon: Medal },
  { id: 'bike', label: 'Bicicletta', Icon: Bike },
  { id: 'camera', label: 'Fotografia', Icon: Camera },
  { id: 'palette', label: 'Arte', Icon: Paintbrush },
  { id: 'party', label: 'Feste', Icon: PartyPopper },
  { id: 'sparkles', label: 'Benessere / beauty', Icon: Sparkles },
  { id: 'crown', label: 'Lusso', Icon: Crown },
  { id: 'gem', label: 'Gioielli', Icon: Gem },

  /* — Studio e lavoro — */
  { id: 'school', label: 'Scuola', Icon: School },
  { id: 'graduation', label: 'Università', Icon: GraduationCap },
  { id: 'document', label: 'Documenti', Icon: FileText },
  { id: 'scroll', label: 'Contratti', Icon: ScrollText },
  { id: 'newspaper', label: 'Abbonamenti info', Icon: Newspaper },
  { id: 'pen', label: 'Cancelleria', Icon: PenLine },
  { id: 'clipboard', label: 'Pratiche / liste', Icon: ClipboardList },
  { id: 'user', label: 'Personale', Icon: User },
  { id: 'users', label: 'Famiglia / gruppo', Icon: Users },
  { id: 'handshake', label: 'Collaborazioni', Icon: Handshake },
  { id: 'heart_hand', label: 'Donazioni', Icon: HeartHandshake },

  /* — Salute — */
  { id: 'hospital', label: 'Ospedale', Icon: Hospital },
  { id: 'ambulance', label: 'Emergenze mediche', Icon: Ambulance },
  { id: 'syringe', label: 'Vaccini / cure', Icon: Syringe },
  { id: 'pill_bottle', label: 'Medicinali', Icon: PillBottle },
  { id: 'microscope', label: 'Analisi', Icon: Microscope },
  { id: 'flask', label: 'Laboratorio', Icon: FlaskConical },
  { id: 'test_tube', label: 'Check-up', Icon: TestTube },
  { id: 'scissors', label: 'Parrucchiere', Icon: Scissors },

  /* — Finanza — */
  { id: 'wallet', label: 'Portafoglio', Icon: Wallet },
  { id: 'coins', label: 'Spiccioli', Icon: Coins },
  { id: 'piggy', label: 'Risparmi', Icon: PiggyBank },
  { id: 'circle_dollar', label: 'Spese generiche', Icon: CircleDollarSign },
  { id: 'receipt', label: 'Scontrini / note', Icon: Receipt },
  { id: 'percent', label: 'Commissioni', Icon: Percent },
  { id: 'scale', label: 'Legale / tasse', Icon: Scale },
  { id: 'shield', label: 'Polizza', Icon: Shield },
  { id: 'shield_check', label: 'Assicurazione', Icon: ShieldCheck },
  { id: 'umbrella', label: 'Previdenza', Icon: Umbrella },
  { id: 'trending_up', label: 'Investimenti +', Icon: TrendingUp },
  { id: 'trending_down', label: 'Minusvalenze', Icon: TrendingDown },
  { id: 'bitcoin', label: 'Crypto', Icon: Bitcoin },
  { id: 'transfer', label: 'Bonifici', Icon: ArrowLeftRight },

  /* — Tech — */
  { id: 'wifi', label: 'Internet', Icon: Router },
  { id: 'cloud', label: 'Cloud / SaaS', Icon: Cloud },
  { id: 'server', label: 'Hosting', Icon: Server },
  { id: 'cpu', label: 'Hardware', Icon: Cpu },
  { id: 'disk', label: 'Archiviazione', Icon: HardDrive },
  { id: 'monitor', label: 'Schermo', Icon: Monitor },
  { id: 'tablet', label: 'Tablet', Icon: Tablet },
  { id: 'watch', label: 'Smartwatch', Icon: Watch },
  { id: 'webcam', label: 'Videocall', Icon: Webcam },
  { id: 'printer', label: 'Stampante', Icon: Printer },
  { id: 'plug', label: 'Prese / alimentatori', Icon: Plug },
  { id: 'plug_zap', label: 'Elettronica', Icon: PlugZap },
  { id: 'battery', label: 'Batterie', Icon: BatteryMedium },

  /* — Natura e animali — */
  { id: 'dog', label: 'Cane', Icon: Dog },
  { id: 'cat', label: 'Gatto', Icon: Cat },
  { id: 'rabbit', label: 'Coniglio / piccoli', Icon: Rabbit },
  { id: 'bird', label: 'Uccelli', Icon: Bird },
  { id: 'flower', label: 'Fiori', Icon: Flower2 },
  { id: 'tree', label: 'Giardino', Icon: TreePine },
  { id: 'leaf', label: 'Natura', Icon: Leaf },
  { id: 'sprout', label: 'Orto', Icon: Sprout },
  { id: 'recycle', label: 'Ecologia', Icon: Recycle },
  { id: 'mountain', label: 'Montagna', Icon: Mountain },
  { id: 'tent', label: 'Campeggio', Icon: Tent },
  { id: 'sun', label: 'Vacanza estiva', Icon: Sun },
  { id: 'moon', label: 'Notte / turni', Icon: Moon },
  { id: 'snowflake', label: 'Sci / inverno', Icon: Snowflake },

  /* — Altro — */
  { id: 'hotel', label: 'Hotel', Icon: Hotel },
  { id: 'bed', label: 'Pernottamento', Icon: BedDouble },
  { id: 'luggage', label: 'Valigie', Icon: Luggage },
  { id: 'mail', label: 'Posta', Icon: Mail },
  { id: 'send', label: 'Corriere', Icon: Send },
  { id: 'rss', label: 'Abbonamenti digitali', Icon: Rss },
  { id: 'church', label: 'Enti religiosi', Icon: Church },
];

const idToIcon = new Map(CATEGORY_ICON_CHOICES.map((c) => [c.id, c.Icon]));

export function defaultCategoryIconId(): string {
  return 'tag';
}

export function getCategoryLucideIcon(stored?: string | null): LucideIcon {
  if (!stored?.trim()) return Tag;
  const t = stored.trim();
  return idToIcon.get(t) ?? Tag;
}

type CategoryIconProps = {
  iconId?: string | null;
  size?: number;
  className?: string;
  title?: string;
};

export function CategoryIcon({ iconId, size = 20, className, title }: CategoryIconProps) {
  const I = getCategoryLucideIcon(iconId);
  const icon = (
    <I
      size={size}
      strokeWidth={STROKE}
      className={className ?? 'category-icon-svg'}
      aria-hidden
    />
  );
  if (title) {
    return (
      <span className="category-icon-wrap" title={title}>
        {icon}
      </span>
    );
  }
  return icon;
}
